import React, { useContext, useEffect, useState } from "react";
import { Context } from "../../../Context/context";
import { saveBrushSetting } from "../../../../services/galleryService"
import type { SavedBrushedObject } from "@/types"
import {
  loadBrushState,
  saveBrushAPI
} from "../../SketchUtilities/BrushLibrary/BrushUtilities";
import { THREE_INST } from "../../SketchUtilities/Three/threeSingleton";
import api from "../../../apiUtilities";
import { LoadBrushModal } from "./LoadBrush";
import { SaveBrushModal } from "./SaveBrush";
import { BrushState } from "../../../TypesAndConstants/types";

interface Props {
  openSave: boolean;
  openLoad: boolean;
  closeMenus: () => void;
}

export const BrushSaveContainerMobile = (props: Props) => {
  let three = THREE_INST.getInst();
  const { state, dispatch } = useContext(Context);

  const [savedBrushes, setSavedBrush] = useState<SavedBrushedObject[]>([]);
  const [saveOpen, setSaveOpen] = useState<boolean>(false);
  const [saveSelectOpen, setSelectOpen] = useState<boolean>(false);

  /* eslint react-hooks/exhaustive-deps: off */
  useEffect(() => {
    loadBrushes();
  }, [state.userBrushes]);

  useEffect(() => {
    if (props.openLoad !== saveSelectOpen) {
      setSelectOpen(props.openLoad);
    }
  }, [props.openLoad]);

  useEffect(() => {
    if (props.openSave !== saveOpen) {
      setSaveOpen(props.openSave);
    }
  }, [props.openSave]);

  useEffect(() => {
    three.obj.doNotRender = saveOpen || saveSelectOpen;
  }, [saveOpen, saveSelectOpen]);

  const loadBrushes = () => {
    const brushes = state.userBrushes;
    if (brushes) {
      setSavedBrush(brushes);
    }
  };

  const loadSaveBrush = (brushID: number) => {
    const savedBrushes = state.userBrushes;
    if (savedBrushes) {
      const selectedBrush = savedBrushes.find((i) => {
        return i.id === brushID;
      });

      if (selectedBrush) {
        dispatch({
          type: "load_Brush",
          value: loadBrushState(selectedBrush.brushState, state),
        });
        three.obj.setAlphaTexture(selectedBrush.brushState.activeBrush);
        three.obj.setAnimationMode(selectedBrush.brushState.animation);
        three.obj.setPreviewTexture(selectedBrush.brushState.activeBrush);
      }
    }
  };

  const mainStyle = {
    fontFamily: "'amatic', cursive",
    position: "fixed",
    bottom: "0%",
    display: "flex",
    justifyContent: "start",
    width: "100%",
    left: 0,
    zIndex: 1000,
  };

  return (
    <div id="brushSaveContainer" style={mainStyle as any}>
      {SaveBrushModal({
        open: saveOpen,
        close: () => {
          setSaveOpen(false);
          props.closeMenus();
        },
        handleSave: (title: string) => {
          const newBrush = saveBrushAPI(state);
          const newBrushObject = {
            name: title,
            brushState: newBrush as BrushState,
            id: Date.now(),
          };

          savedBrushes.push(newBrushObject as SavedBrushedObject);
          setSavedBrush(savedBrushes);
          saveBrushSetting( savedBrushes )
        },
      })}
      {LoadBrushModal({
        open: saveSelectOpen,
        close: () => {
          setSelectOpen(false);
          props.closeMenus();
        },
        brushes: savedBrushes !== undefined ? savedBrushes : [],
        handleSelect: (brush: number) => {
          loadSaveBrush(brush);
        },
        deleteBrush: (id: number) => {
          const newBrushes = savedBrushes?.filter((b) => {
            return b.id !== id;
          });

          api.deleteUserBrush(JSON.stringify(newBrushes) || "");
          saveBrushSetting  (newBrushes || []);
          setSelectOpen(!saveSelectOpen);
        },
      })}
    </div>
  );
};
